import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './engagement-card.module.less';

const WistiaMagicStrings = {
  padding: 'wistia_responsive_padding',
  wrapper: 'wistia_responsive_wrapper',
  embed: 'wistia_embed videoFoam=true',
  swatch: 'wistia_swatch',
};

export const WistiaVideo = ({ videoId, onWistiaClick }) => {
  return (
    <div
      className={classnames(WistiaMagicStrings.embed, 'popover=true', `wistia_async_${videoId}`, styles.wistia_embed)}
      onClick={onWistiaClick}
    >
      <div className={classnames(WistiaMagicStrings.swatch, styles.wistia_swatch)} />
    </div>
  );
};

WistiaVideo.propTypes = {
  onWistiaClick: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
};
